import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface StatCardProps {
    label: string
    value: ReactNode
    hint?: ReactNode
    className?: string
}

export default function StatCard({ label, value, hint, className }: StatCardProps) {
    return (
        <div className={cn('border-line-strong flex min-w-0 flex-col gap-3 rounded-lg border bg-white/[0.015] p-[13px]', className)}>
            <span className='caption-style text-soft block truncate'>
                {label}
            </span>
            <span className='block text-[22px] leading-none font-medium tabular-nums'>
                {value}
            </span>
            {hint && (
                <span className='caption-style text-subtle block truncate'>
                    {hint}
                </span>
            )}
        </div>
    )
}
